import React, { useEffect, useState } from "react";
import "./index.css";
import formatCurrency from "../common/CurrencyFormatter";
import ApiService from "../../Service/ApiService";
import { notify } from "../common/Toast";
import { useNavigate } from "react-router-dom";
import { Card, Col, Modal, Row } from "antd";
import Title from "antd/es/typography/Title";

const BookingItem = ({ bookingDetails }) => {
  const navigate = useNavigate();
  const [loggedInUser, setLoggedInUser] = useState();

  useEffect(() => {
    const fetchUser = async () => {
      const data = await ApiService.getUserProfile();
      if (!data) {
        notify("Failed to fetch current user info");
      }
      setLoggedInUser(data);
    };
    fetchUser();
  }, []);

  const canCompleteBooking = (bookingDetails) => {
    if (!bookingDetails.confirmed || bookingDetails.completed) return false;
    return true;
  };

  const canArchiveBooking = (bookingDetails) => {
    return !bookingDetails.confirmed || bookingDetails.completed;
  };

  const canConfirmBooking = (bookingDetails) => {
    return !bookingDetails.confirmed;
  };

  const achieveBooking = (type, bookingId) => {
    Modal.confirm({
      title: `${type.charAt(0).toUpperCase() + type.slice(1)} Booking`,
      content: `Are you sure you want to ${type} this booking?`,
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        let response;
        switch (type) {
          case "cancel":
            response = await ApiService.cancelBooking(bookingId);
            break;
          case "confirm":
            response = await ApiService.confirmBooking(bookingId);
            break;
          case "complete":
            response = await ApiService.completeBooking(bookingId);
            break;
          default:
            return;
        }
        if (response) {
          navigate("/admin/manage-bookings");
        }
      },
    });
  };

  const handleUserCancel = (bookingId) => {
    Modal.confirm({
      title: "Cancel Booking",
      content: "Are you sure you want to cancel this booking?",
      okText: "Yes, Cancel Booking",
      okButtonProps: { danger: true },
      cancelText: "No",
      onOk: async () => {
        const response = await ApiService.cancelBooking(bookingId);
        if (response) {
          notify("Booking cancelled.", "success");
          navigate("/find-booking");
        }
      },
    });
  };
  return (
    <div className="booking-details">
      <div className="find-booking-room booking-details-content">
        <Row gutter={[16, 16]}>
          {bookingDetails.rooms.map((room) => (
            <Col
              span={12}
              key={room.id}
              style={{ minWidth: 300, flex: "1 1 200px" }}
            >
              <Card
                hoverable
                cover={
                  <img
                    alt={room.roomName}
                    src={room.roomPhotoUrl}
                    style={{
                      height: "200px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                }
              >
                <Title level={4}>{room.roomName}</Title>
                <p>Max Persons: {room.maxPersons}</p>
                <br />
                <p strong>Cost: {formatCurrency(room.roomPrice, "en-US", room.hotel?.currency || "USD")} / night</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <div className="booking-details-content">
        <h3>Booking Details </h3>
        <p>
          <span>Confirmation Code</span>
          {bookingDetails.bookingConfirmationCode}
        </p>
        <p>
          <span>Check-in Date</span> {bookingDetails.checkInDate}
        </p>
        <p>
          <span>Check-out Date</span> {bookingDetails.checkOutDate}
        </p>
        <p>
          <span>Num Of Guests</span> {bookingDetails.totalNumberOfGuests}
        </p>
        <p>
          <span>Total Cost</span> {formatCurrency(bookingDetails.totalCost, "en-US", bookingDetails.hotel?.currency || "USD")}
        </p>

        {bookingDetails.user && (
          <>
            <h3>Client Details</h3>
            <p>
              <span>Name</span>
              {bookingDetails.user.name}
            </p>
            <p>
              <span>Email</span> {bookingDetails.user.email}
            </p>
            <p>
              <span>Phone Number</span> {bookingDetails.user.phoneNumber}
            </p>
          </>
        )}

        <h3>Confirmation Details</h3>
        <p>
          <span>Confirmation Status</span>{" "}
          {bookingDetails.deleted
            ? "Archived"
            : bookingDetails.completed
            ? "Completed"
            : bookingDetails.confirmed
            ? "Confirmed"
            : "Awaiting confirmation"}
        </p>

        {loggedInUser &&
          (loggedInUser.role === "SUPERADMIN" ||
            loggedInUser.role === "ADMIN") && (
            <div className="booking-actions">
              {!bookingDetails.confirmed && (
                <button
                  disabled={!canConfirmBooking(bookingDetails)}
                  onClick={() => achieveBooking("confirm", bookingDetails.id)}
                  title={
                    !canConfirmBooking(bookingDetails)
                      ? "Cannot confirm a deleted booking or one that has been confirmed"
                      : ""
                  }
                >
                  Confirm Booking
                </button>
              )}
              {!bookingDetails.completed && (
                <button
                  className="complete-booking"
                  disabled={!canCompleteBooking(bookingDetails)}
                  onClick={() => achieveBooking("complete", bookingDetails.id)}
                  title={
                    !canCompleteBooking(bookingDetails)
                      ? "Cannot complete a booking before it is confirmed, the guest has checked out or after it is completed"
                      : ""
                  }
                >
                  Complete Booking
                </button>
              )}
              {!bookingDetails.deleted && (
                <button
                  disabled={!canArchiveBooking(bookingDetails)}
                  className="archive-booking"
                  onClick={() => achieveBooking("cancel", bookingDetails.id)}
                  title={
                    !canArchiveBooking(bookingDetails)
                      ? "Cannot archive a booking before it is completed"
                      : ""
                  }
                >
                  Archive Booking
                </button>
              )}
            </div>
          )}

        {loggedInUser &&
          loggedInUser.role !== "SUPERADMIN" &&
          loggedInUser.role !== "ADMIN" &&
          !bookingDetails.confirmed &&
          !bookingDetails.deleted && (
            <div className="booking-actions">
              <button
                className="archive-booking"
                onClick={() => handleUserCancel(bookingDetails.id)}
              >
                Cancel Booking
              </button>
            </div>
          )}
      </div>
    </div>
  );
};

export default BookingItem;
